import React, { useCallback, useState } from 'react';
import { useStyletron } from 'baseui';
import type { OnChangeParams, Value } from 'baseui/select';
import { ActionHeader } from '../common';
import { Tabs } from '../const';
import { useLabelListData } from '../hooks/use-label-list-data';
import { useTaskQuestionnaire } from '../hooks/use-task-questionnaire';
import { useSidePanel } from '../side-panel-provider';
import { LabelList } from './label-list';
import { LabelSearchSelect } from './label-search-select';
export const LabelPanel = () => {
  const [css, theme] = useStyletron();
  const {
    taskQuestionnaireComponent,
    additionalOptionsComponent,
    createRelationshipComponent
  } = useSidePanel();
  const [inputValue, setInputValue] = useState('');
  const [selectedValue, setSelectedValue] = useState<Value>([]);
  const {
    openTaskQuestionnaire
  } = useTaskQuestionnaire({
    taskQuestionnaireComponent
  });
  const {
    filterOptions
  } = useLabelListData({
    annotationsTabKey: Tabs.ANNOTATIONS.key,
    filterText: inputValue
  });
  const handleSelectChange = useCallback((params: OnChangeParams) => {
    setSelectedValue(params.value);
    const nextValue = params.value[0]?.label?.toString() ?? '';
    setInputValue(nextValue);
  }, []);
  const handleInputChange = useCallback((event: React.SyntheticEvent<HTMLInputElement>) => {
    const nextValue = event.currentTarget?.value ?? '';
    setInputValue(nextValue);
  }, []);
  return <div className={css({
    width: '100%',
    height: `calc(100% - ${theme.sizing.scale500})`,
    paddingTop: theme.sizing.scale500,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: theme.sizing.scale600
  })}>
      <div className={css({
      display: 'flex',
      flexDirection: 'column',
      gap: theme.sizing.scale400,
      flex: 1,
      overflow: 'hidden'
    })}>
        <LabelSearchSelect options={filterOptions} value={selectedValue} onChange={handleSelectChange} onInputChange={handleInputChange} />
        <LabelList filterText={inputValue} />
      </div>
      <div>
        {additionalOptionsComponent && additionalOptionsComponent()}
        {createRelationshipComponent && createRelationshipComponent()}
        {taskQuestionnaireComponent && <ActionHeader title="Task Questions" status={taskQuestionnaireComponent?.status} onActionClick={openTaskQuestionnaire} />}
      </div>
    </div>;
};